import { Injectable } from '@angular/core';
import { IPagingRequestModel } from '../../interfaces/IPagingRequestModel.interface';
import { IItemCreateDto, ItemModel, ItemPatchDto, RecordPaymentDTO, RecordPaymentTwoPartDTO, VolunteerShiftDto } from '../../interfaces/items.interface';
import { PagedResult } from '../../interfaces/IPagingResponseModel.interface';
import { map, Observable } from 'rxjs';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { HttpWrapperService } from '../http-wrapper.service';
import { IVolunteerShifts } from '../../interfaces/community.interface';

@Injectable({
  providedIn: 'root'
})
export class ItemService {

  constructor(private readonly httpWrapperService: HttpWrapperService) { }


    getItemsByCampaignId(campaignid: number, isAllData:boolean, request: IPagingRequestModel,isPrivatelyShared=false): Observable<PagedResult<ItemModel>> {
      const url = `item/list?campaignId=${campaignid}&allData=${isAllData}&isPrivatelyShared=${isPrivatelyShared}`;
      const options: IHttpRequestOptions = {
        url: url,
        body : request
      };
      return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: PagedResult<ItemModel>) => response)
      );
    }

    getItems(type:string,id: number, isAllData:boolean, request: IPagingRequestModel, isPrivateLink: boolean = false): Observable<PagedResult<ItemModel>> {
      let url='';
      if(type=="campaign"){
        url = `item/list?campaignId=${id}&allData=${isAllData}&isPrivatelyShared=${isPrivateLink}`;
      }
      else{
         url = `communityStories/list/${id}?allData=${isAllData}`;
      }
      const options: IHttpRequestOptions = {
        url: url,
        body : request
      };
      return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: PagedResult<ItemModel>) => response)
      );
    }

    saveItem(item: IItemCreateDto): Observable<any> {
      const url = `item`;
      const options: IHttpRequestOptions = {
        url: url,
        body : item
      };
      return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: any) => response)
      );
    }

    updateItemLocation(id:number,item: ItemPatchDto): Observable<any> {
      const url = `item/${id}`;
      const options: IHttpRequestOptions = {
        url: url,
        body : item
      };
      return this.httpWrapperService.patchFromApiGateWay(options).pipe(
        map((response: any) => response)
      );
    }

    getItemById(id: number, isPrivatelyShared=false): Observable<ItemModel> {
      const url = `item/${id}?isPrivatelyShared=${isPrivatelyShared}`;
      const options: IHttpRequestOptions = {
        url: url,
      };
      return this.httpWrapperService.getFromApiGateWay(options).pipe(
        map((response: ItemModel) => response),
      );
    }

    getItemDetailById(id: number,isPrivatelyShared=false): Observable<ItemModel> {
      const url = `item/detail/${id}?isPrivatelyShared=${isPrivatelyShared}`;
      const options: IHttpRequestOptions = {
        url: url,
      };
      return this.httpWrapperService.getFromApiGateWay(options).pipe(
        map((response: ItemModel) => response),
      );
    }

    deleteItem(id: number): Observable<boolean> {
      const url = `item/${id}`;
      const options: IHttpRequestOptions = {
        url: url,
      };
      return this.httpWrapperService.deleteFromApiGateWay(options).pipe(
        map((response: boolean) => response)
      );
    }

    generateStripeLink(payload: { itemId: number, itemPrice: number }): Observable<string> {
      const url = `itemstripe`;
      const options: IHttpRequestOptions = {
        url: url,
        body : payload
      };
      return this.httpWrapperService.postFromApiGateWay(options);
    }
    recordPaymentAPI(id: number,item:RecordPaymentDTO): Observable<RecordPaymentDTO> {
      const url = `ItemPaymentRecord/${id}`;
      const options: IHttpRequestOptions = {
        url: url,
        body :item
      };
      return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: any) => response)
      );
    }

    recordPaymentTwoPartAPI(donorId: number, item: RecordPaymentTwoPartDTO): Observable<void> {
      const url = `ItemPaymentRecord/two-part/${donorId}`;
      const options: IHttpRequestOptions = {
        url: url,
        body: item
      };
      return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: any) => response)
      );
    }

    cloneItem(campaignId:number,itemId:number):Observable<boolean>{
    const url=`CampaignClone/item/${campaignId}/${itemId}`;
    const options:IHttpRequestOptions={url:url};
      return this.httpWrapperService
      .postFromApiGateWay(options).pipe(      
        map((response: any) => response)
    )
  }
}
